import useCatalog from '../hooks/useCatalog';
import { LINE_STYLES, PATTERNS, patternSwatch, ensurePatterns, BUILD_LINES, BUILD_PATTERNS } from '../lib/drawStyles';

// legend in building / facade: section pins, facade & scaffold catalog items, studio line and hatch styles
export default function BuildingLegend({ t }) {
  const { items } = useCatalog();
  const own = items.filter((x) => x.sector === 'building');
  ensurePatterns();
  return (
    <>
      <b data-testid="legend-bd-sections">{t.reports}</b>
      {[['#0A2540', t.legBdOpen], ['#ff6a13', t.legBdActive], ['#16a34a', t.legBdDone]].map(([c, l]) => <div key={l} className="lg-row"><i className="lg-dot" style={{ background: c }} />{l}</div>)}
      {['facade', 'scaffold'].map((cat) => (
        <div key={cat} data-testid={`legend-bd-${cat}`}>
          <b>{t['cat_' + cat]}</b>
          {own.filter((x) => x.cat === cat).map((x) => <div key={x.id} className="lg-row" data-testid={`legend-bd-${x.id}`}><i className="lg-dot lg-sym" style={{ background: x.color }}>{x.sym}</i>{x.name}</div>)}
        </div>
      ))}
      <b data-testid="legend-bd-studio">{t.dsLegend}</b>
      {BUILD_LINES.map((k) => <div key={k} className="lg-row"><i className="lg-line" style={{ background: LINE_STYLES[k] }} />{t['dsSt_' + k]}</div>)}
      {BUILD_PATTERNS.map((k) => <div key={k} className="lg-row" title={PATTERNS[k]}><span dangerouslySetInnerHTML={{ __html: patternSwatch(k) }} />{t['dsSt_' + k]}</div>)}
    </>
  );
}
